export default __webpack_public_path__ + "static/media/transition_img.9452e296.png";